var render = function render(){var _vm=this,_c=_vm._self._c;return _c('component',_vm._b({nativeOn:{"!click":function($event){return _vm.handleClick.apply(null, arguments)}}},'component',_vm.linkProps(),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }